import {
  getLocalStorageItem,
  removeLocalStorageItem,
  setLocalStorageItem,
} from '../storage';

import { GUEST_LIKED_PRODUCTS_STORAGE_KEY } from './constants';

const listeners = new Set<() => void>();

export function subscribeGuestLikes(onStoreChange: () => void) {
  function handleStorage(event: StorageEvent) {
    if (event.key === null || event.key === GUEST_LIKED_PRODUCTS_STORAGE_KEY) {
      onStoreChange();
    }
  }
  listeners.add(onStoreChange);
  window.addEventListener('storage', handleStorage);
  return () => {
    listeners.delete(onStoreChange);
    window.removeEventListener('storage', handleStorage);
  };
}

function notifyGuestLikesChanged() {
  listeners.forEach((listener) => listener());
}

export function getStoredGuestLikes() {
  return getLocalStorageItem(GUEST_LIKED_PRODUCTS_STORAGE_KEY);
}

export function setStoredGuestLikes(value: string) {
  setLocalStorageItem(GUEST_LIKED_PRODUCTS_STORAGE_KEY, value);
  notifyGuestLikesChanged();
}

export function clearStoredGuestLikes() {
  removeLocalStorageItem(GUEST_LIKED_PRODUCTS_STORAGE_KEY);
  notifyGuestLikesChanged();
}
